import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebook, 
  FaTwitter, 
  FaLinkedin, 
  FaInstagram, 
  FaGithub,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaInfoCircle,
  FaUsers,
  FaBriefcase,
  FaHandshake,
  FaCogs,
  FaGraduationCap,
  FaIndustry,
  FaFileContract,
  FaUserShield,
  FaCookie,
  FaShieldAlt,
  FaCloud,
  FaChartLine,
  FaLaptopCode,
  FaServer,
  FaVial,
  FaBrain,
  FaHeartbeat,
  FaUniversity,
  FaTshirt,
  FaBolt,
  FaSearch,
  FaLandmark,
  FaYoutube
} from 'react-icons/fa';

import { PLATFORM_LOGIN_URL } from '../config/platformConfig';

// Company info
const companyInfo = {
  name: "CloudDigify",
  tagline: "Transforming What's Next",
  addresses: [
    {
      label: "Greater Noida Office",
      value: "Gaur World SmartStreet, AFOF 54, Plot C, 01, Sector 16B Rd, Greater Noida West, Uttar Pradesh 201301"
    },
    {
      label: "Bengaluru Office",
      value: "9th Floor, Brigade IRV, Nallurhalli Rd, Nallurhalli, Whitefield, Bengaluru, Karnataka 560066"
    }
  ],
  phone: "+91 7011112386",
  email: "contact@clouddigify.com",
  hours: "Mon-Fri: 9:00 AM - 6:00 PM IST"
};

// Social media links
const socialLinks = [
  { icon: <FaLinkedin className="w-5 h-5" />, url: "https://linkedin.com/company/clouddigify", label: "LinkedIn" },
  { icon: <FaTwitter className="w-5 h-5" />, url: "https://twitter.com/clouddigify", label: "Twitter" },
  { icon: <FaFacebook className="w-5 h-5" />, url: "https://facebook.com/clouddigify", label: "Facebook" },
  { icon: <FaInstagram className="w-5 h-5" />, url: "https://instagram.com/clouddigify", label: "Instagram" },
  { icon: <FaYoutube className="w-5 h-5" />, url: "https://youtube.com/@clouddigify", label: "YouTube" },
  { icon: <FaGithub className="w-5 h-5" />, url: "https://github.com/clouddigify", label: "GitHub" }
];

// Footer links organized by sections
const footerLinks = {
  company: [
    { title: "About Us", path: "/about", icon: <FaInfoCircle className="w-4 h-4" /> },
    { title: "Our Culture", path: "/culture", icon: <FaHandshake className="w-4 h-4" /> },
    { title: "Career", path: "/career", icon: <FaBriefcase className="w-4 h-4" /> }
  ],
  services: [
    { title: "Cloud Services", path: "/services/cloud/aws", icon: <FaCloud className="w-4 h-4" /> },
    { title: "DevOps Services", path: "/services/devops/cicd", icon: <FaLaptopCode className="w-4 h-4" /> },
    { title: "Security Services", path: "/services/security/cyber-defence", icon: <FaShieldAlt className="w-4 h-4" /> },
    { title: "Training", path: "/training", icon: <FaGraduationCap className="w-4 h-4" /> },
    { title: "Industries", path: "/industries", icon: <FaIndustry className="w-4 h-4" /> }
  ],
  product: [
    { title: "Overview", path: "/platform", icon: <FaCloud className="w-4 h-4" /> },
    { title: "Features", path: "/platform/features", icon: <FaCogs className="w-4 h-4" /> },
    { title: "Pricing", path: "/platform/pricing", icon: <FaChartLine className="w-4 h-4" /> },
    { title: "Request Demo", path: "/platform/demo", icon: <FaEnvelope className="w-4 h-4" /> }
  ],
  support: [
    { title: "Support", path: "/support", icon: <FaInfoCircle className="w-4 h-4" /> },
    { title: "Contact", path: "/contact", icon: <FaEnvelope className="w-4 h-4" /> }
  ],
  resources: [
    { title: "Terms & Conditions", path: "/terms", icon: <FaFileContract className="w-4 h-4" /> },
    { title: "Privacy Policy", path: "/privacy", icon: <FaUserShield className="w-4 h-4" /> },
    { title: "Cookie Policy", path: "/cookies", icon: <FaCookie className="w-4 h-4" /> },
    { title: "Security", path: "/security", icon: <FaShieldAlt className="w-4 h-4" /> }
  ]
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#101B33] text-white">

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Company Info */}
          <div className="lg:w-2/5 lg:pr-12 border-b lg:border-b-0 lg:border-r border-gray-700 pb-8 lg:pb-0">
            <Link to="/" className="inline-block">
              <h2 className="text-2xl font-bold">{companyInfo.name}</h2>
              <p className="text-gray-400 mt-2">{companyInfo.tagline}</p>
            </Link>
            <div className="mt-6 space-y-4 text-gray-400">
              <div className="flex items-start space-x-3">
                <FaMapMarkerAlt className="w-5 h-5 mt-1 text-blue-500" />
                <div className="space-y-2">
                  {companyInfo.addresses.map((office) => (
                    <div key={office.label}>
                      <p className="text-white/90 font-medium">{office.label}</p>
                      <p>{office.value}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <FaPhone className="w-5 h-5 text-blue-500" />
                <span>{companyInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <FaEnvelope className="w-5 h-5 text-blue-500" />
                <span>{companyInfo.email}</span>
              </div>
              <div className="flex items-center space-x-3">
                <FaClock className="w-5 h-5 text-blue-500" />
                <span>{companyInfo.hours}</span>
              </div>
            </div>
          </div>

          {/* Links Sections */}
          <div className="flex-1 flex flex-col items-center justify-center">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 w-full mx-auto">
              <div>
                <h3 className="text-lg font-semibold mb-4">Company</h3>
                <ul className="space-y-3">
                  {footerLinks.company.map((link, index) => (
                    <li key={index}>
                      <Link to={link.path} className="text-gray-400 hover:text-white transition-colors duration-200">
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Services</h3>
                <ul className="space-y-3">
                  {footerLinks.services.map((link, index) => (
                    <li key={index}>
                      <Link to={link.path} className="text-gray-400 hover:text-white transition-colors duration-200">
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Platform</h3>
                <ul className="space-y-3">
                  {footerLinks.product.map((link, index) => (
                    <li key={index}>
                      <Link to={link.path} className="text-gray-400 hover:text-white transition-colors duration-200">
                        {link.title}
                      </Link>
                    </li>
                  ))}
                  <li>
                    <a
                      href={PLATFORM_LOGIN_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-white transition-colors duration-200"
                    >
                      Login
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Support</h3>
                <ul className="space-y-3">
                  {footerLinks.support.map((link, index) => (
                    <li key={index}>
                      <Link to={link.path} className="text-gray-400 hover:text-white transition-colors duration-200">
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Legal</h3>
                <ul className="space-y-3">
                  {footerLinks.resources.map((link, index) => (
                    <li key={index}>
                      <Link to={link.path} className="text-gray-400 hover:text-white transition-colors duration-200">
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-gray-400 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </div>
            
            {/* Social Links */}
            <div className="flex items-center space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-full transition-colors duration-200"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
